// Shared by the application and Ant Design's detached static overlay roots.
export const APP_FONT_FAMILY = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif";
export const APP_TYPOGRAPHY_THEME = {
  token: { fontFamily: APP_FONT_FAMILY },
  components: { Button: { fontWeight: 500 } },
};
